import React, { useEffect, useState } from 'react';
import { Table, Button, Space, Tag, PopconfirmProps, message, Popconfirm, Switch, Modal } from 'antd';
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { deleteRewards, getAllRewards, updateRewards } from '../../actions/business';
import { capitalizeFirstLetter, truncateText } from '@utils/comman';

interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    email: string;
    businessCode: string;
    isRegistered: boolean;
}

const RewardList = ({ handleClose, showModal, handleSubmit }: any) => {
    const navigate= useNavigate();
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const loading = useSelector((state: any) => state?.General?.loading);
    const rewardList = useSelector((state:any)=> state?.Business?.rewardList)
    const businessDetails = useSelector((state:any)=> state?.Business?.businessDetails)
    const [pageSize, setPageSize] = useState(10);
    const [data, setData] = useState<DataType[]>(rewardList?.data);
    const [open, setOpen] = useState(false);
    const [selectedData, setSelectedData] = useState<any>();
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();

    const getAllRewardList=(payload: any)=> {
        dispatch(
            getAllRewards(payload, (resp: any) => {
                if (resp?.status === 200) {
                    setData(resp?.data?.data || []);
                    setPagination(resp?.pagination);
                }
            })
        );
    }

    const confirm: any = (status:any, record: any) => {
        let payload = {
            isActive: status,
            id: record?.id || selectedData?.id
        }
        dispatch(updateRewards(payload, (resp: any) => {
            // setAtiveStep('3')
            const payload = { limit: pageSize, page, isReferral: 1 };
            getAllRewardList(payload)
            setOpen(false);

        }))
      };
      
      const handleOk = (status: any, data: any) => {
        confirm(status, selectedData)
      };
    
      const handleCancel = () => {
        setOpen(false);
      };

      const handleChange =(evt:any, record:any)=> {
        setSelectedData(record);
        if(!evt) {
            setOpen(true);
        } else {
            confirm(true, selectedData)
        }
      }
    

    const columns: ColumnsType<DataType> = [
        {
            title: 'Reward Name',
            dataIndex: 'rewardName',
            key: 'rewardName',
            width: 150,
            sorter: (a:any, b:any) => a?.rewardName?.localeCompare(b?.rewardName),
            render: (text) => <>{text}</>,
        },
        {
            title: 'Referrer Reward Type',
            dataIndex: '',
            width: 180,
            key: '',
            // sorter: (a:any, b:any) => a?.referrerRewardType?.localeCompare(b?.referrerRewardType),
            render: (text) => {
                return <Tag color='orange'>
                    {text?.referrerRewardType === 'percentage' ?
                        `% Commission` :
                        text?.referrerRewardType === 'cash' ?
                          `Cash Reward` :
                          text?.referrerRewardType === 'no-reward' ?
                            `No Reward` :
                            text?.referrerRewardType === 'coupon' ?
                              `Voucher or Freebie` : ""}
                </Tag>},
        },   
        {
            title: 'Referrer Reward Value',
            dataIndex: 'referrerRewardValue',
            key: 'referrerRewardValue',
            align: 'center',
            width: 180,
            sorter: (a:any, b:any) => a.referrerRewardValue.localeCompare(b.referrerRewardValue),
            render: (text) => <>{text}</>,
        },
        // ********** Later we'll use ***************** //
        // {
        //     title: 'Referral Reward Type',
        //     dataIndex: '',
        //     key: '',
        //     // sorter: (a:any, b:any) => a?.referralRewardType?.localeCompare(b?.referralRewardType),
        //     render: (text) => {
        //     return text?.referralRewardType && <Tag color='orange'>
        //         {text?.referralRewardType === 'percentage' ?
        //             `% Commission` :
        //             text?.referralRewardType === 'cash' ?
        //               `Cash Reward` :
        //               text?.referralRewardType === 'no-reward' ?
        //                 `No Reward` :
        //                 text?.referralRewardType === 'coupon' ?
        //                   `Voucher or Freebie` : ""}
        //     </Tag>},
        // },
        // {
        //     title: 'Referral Reward Value',
        //     dataIndex: 'referralRewardValue',
        //     key: 'referralRewardValue',
        //     align: 'center',
        //     sorter: (a:any, b:any) => a.referralRewardValue.localeCompare(b.referralRewardValue),
        //     render: (text) => <div className='text-center'>{text}</div>,
        // },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: 350,
            // align: 'center',
            sorter: (a:any, b:any) => a.description.localeCompare(b.description),
            render: (text) => <div title={text} className='text-center'>{text ? text : ''}</div>,
        },
        {
            title: 'Action',
            align: 'center',
            key: 'action',
            width: 100,
            render: (_, record: any) => (
                <Space size="middle" direction="horizontal" style={{ width: ' 100%', justifyContent: 'center' }}>
                    <Switch
                        className={`custom-switch ${record?.isActive ? 'active-switch' : 'disabled-switch'}`}
                        onChange={(evt: any) => {
                            setSelectedData(record);
                            if (evt) {
                                confirm(true, record);
                            } else {
                                handleChange(evt, record);
                            }
                        }}
                        checkedChildren="No"
                        unCheckedChildren="Yes"
                        checked={record?.isActive}
                        style={{
                            backgroundColor: record?.isActive ? '#F47523' : '#d9d9d9', // Custom color when checked and default when unchecked
                            borderColor: record?.isActive ? '#F47523' : '#F47523',
                            color: record?.isActive ? '#fff' : '#F47523',  // White text when active, black when disabled
                            opacity: record?.isActive ? 1 : 0.8,       // Reduced opacity when disabled
                        }}
                    />
                    <Button size='small' onClick={() => handleClose(record)} disabled={!record?.isActive}>
                        <EditOutlined />
                    </Button>
                </Space>
            ),
          }
    ];

    useEffect(() => {
        const payload = { limit: pageSize, page, isReferral: 1 };
        getAllRewardList(payload)
    }, [page, pageSize, dispatch, showModal ]);

    const handleTableChange = (pagination: any) => {
        setPage(pagination?.current);
        setPageSize(pagination?.pageSize);
    };

    let businessUrl:string = businessDetails?.url;

    return (
        <div>
            <div className="">
                <div className="">
                    <div className='d-flex justify-content-between'>
                        <div className="bodycardheading">Rewards</div>
                        <div className=''>
                            <Button type='primary' className='btn btn-primary' style={{ marginRight: '5px', height: '39px', fontSize: '12px'}} onClick={()=> window.open(businessUrl,  '_blank', 'noopener,noreferrer')}>Promotional Page</Button>
                            <Button type='primary' className='btn btn-primary' style={{ marginRight: '5px', height: '39px', fontSize: '12px'}} onClick={()=> navigate('/dashboard')}>Go to Dashboard</Button>
                            <Button type='primary' className='btn btn-primary' style={{ height: '39px', fontSize: '12px'}} onClick={()=> handleClose({})}>Add Reward</Button>
                        </div>
                    </div>
                    <div className="cardContentbody">
                        <div className="responsivetable">
                            <Table
                                size='small'
                                columns={columns}
                                dataSource={data || []}
                                loading={loading}
                                pagination={{
                                    total: pagination?.totalItems,
                                    pageSize,
                                    current: page,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['20', '50'],
                                }}
                                scroll={{ y: 264, x: 800 }}
                                onChange={handleTableChange}
                            />
                        </div>
                        {data?.length ? <div className='finish-btn mt-15'>
                            <Button type='primary' className='btn btn-primary' style={{ marginRight: '5px', height: '39px', fontSize: '12px'}} onClick={() => handleSubmit(true)}>Next</Button>
                        </div> : ""}
                    </div>
                </div>
            </div>
            <Modal
                open={open}
                title="Are you sure you want to deactivate?"
                onOk={() => handleOk(false, selectedData)}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" className='btn btn-outline-primary-md' onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="submit" className='btn btn-primary-md' type="primary" loading={loading} onClick={() => handleOk(false, selectedData)}>
                        Ok
                    </Button>
                ]}
            >
                Once deactivated it won't be available on your business page.
            </Modal>
        </div>
    );
};

export default RewardList;
